import {EnrollmentReasonValidateParam, validateAddressBuilding, validateAddressCity, validateAddressPrefectureCode, validateAddressStreet, validateAgreeCheck, validateBirthdayCombination, validateBirthdayDay, validateBirthdayMonth, validateBirthdayYear, validateEnrollmentReason, validateExtendMetaData, ValidateExtendMetaDataParam, validateFamilyName, validateFamilyNameKana, validateFirstName, validateFirstNameKana, validateGender, validatePassword, validatePhoneMobile, validatePhoneTel, validatePostCode} from './MembersValidation'
import {validateConvenienceStore, validateCreditCardExpireMonth, validateCreditCardExpireYear, validateCreditCardHolderName, validateCreditCardNumber, validateCreditCardSecurityCode, validateFutureExpireDate, validateMobileCarrier, validatePaymentInputMethod, validatePaymentInputTerm} from './PaymentInputInfoValidation'
import {ContractMethod, ContractTerm, ConvenienceStoreKey, CreditCardType, MobileCarrierKey} from '../../Props/ContractInputInfo'
import {Optional} from '../../../Common/TypeHelper'

export type ValidationSignupInput = {
  agreedIdList: number[]
  familyName: string
  firstName: string
  familyNameKana: string
  firstNameKana: string
  gender: string
  birthdayYear: string
  birthdayMonth: string
  birthdayDay: string
  postCode: string
  addressPrefectureCode: string
  addressCity: string
  addressStreet: string
  addressBuilding: string
  phoneMobile: string
  phoneTel: string
  password: string
  paymentInputTerm: ContractTerm
  paymentInputMethod: Optional<ContractMethod>
  creditCardType: CreditCardType
  creditCardNumber: string
  creditCardExpireMonth: string
  creditCardExpireYear: string
  creditCardHolderName: string
  creditCardSecurityCode: string
  convenienceStore: ConvenienceStoreKey
  mobileCarrier: MobileCarrierKey
  enrollmentReasonValidateParam: EnrollmentReasonValidateParam
  extendMetaDataParam: ValidateExtendMetaDataParam
}

export type ExtendMetaDataErrors = { [key: string]: string[] }

type CombinationResult = {
  birthdayCombination: string[]
  creditCardFutureExpireDate: string[]
  extendMetaData: Optional<ExtendMetaDataErrors>
}
export type ValidationSignupResultDetail = {
  [K in keyof Omit<ValidationSignupInput, 'extendMetaDataParam'>]: string[]
} & CombinationResult

export type ValidationSignupResult = {
  hasError: boolean
  errors: ValidationSignupResultDetail
}

export const validateMemberSignupInput = (
  input: ValidationSignupInput,
): ValidationSignupResult => {

  const details: ValidationSignupResultDetail = {
    agreedIdList: validateAgreeCheck(input.agreedIdList),
    familyName: validateFamilyName(input.familyName),
    firstName: validateFirstName(input.firstName),
    familyNameKana: validateFamilyNameKana(input.familyNameKana),
    firstNameKana: validateFirstNameKana(input.firstNameKana),
    gender: validateGender(input.gender),
    birthdayYear: validateBirthdayYear(input.birthdayYear),
    birthdayMonth: validateBirthdayMonth(input.birthdayMonth),
    birthdayDay: validateBirthdayDay(input.birthdayDay),
    birthdayCombination: validateBirthdayCombination(
      input.birthdayYear, input.birthdayMonth, input.birthdayDay),
    postCode: validatePostCode(input.postCode),
    addressPrefectureCode: validateAddressPrefectureCode(input.addressPrefectureCode),
    addressCity: validateAddressCity(input.addressCity),
    addressStreet: validateAddressStreet(input.addressStreet),
    addressBuilding: validateAddressBuilding(input.addressBuilding),
    phoneMobile: validatePhoneMobile(input.phoneMobile),
    phoneTel: validatePhoneTel(input.phoneTel),
    password: validatePassword(input.password),
    paymentInputTerm: validatePaymentInputTerm(input.paymentInputTerm),
    paymentInputMethod:
      validatePaymentInputMethod(input.paymentInputMethod),
    creditCardType: [],
    creditCardNumber: validateCreditCardNumber(
      input.paymentInputMethod, input.creditCardType, input.creditCardNumber),
    creditCardExpireMonth: validateCreditCardExpireMonth(
      input.paymentInputMethod, input.creditCardType, input.creditCardExpireMonth),
    creditCardExpireYear: validateCreditCardExpireYear(
      input.paymentInputMethod, input.creditCardType, input.creditCardExpireYear),
    creditCardFutureExpireDate: validateFutureExpireDate(
      input.paymentInputMethod,
      input.creditCardType,
      input.creditCardExpireMonth,
      input.creditCardExpireYear,
    ),
    creditCardHolderName: validateCreditCardHolderName(
      input.paymentInputMethod, input.creditCardType, input.creditCardHolderName),
    creditCardSecurityCode: validateCreditCardSecurityCode(
      input.paymentInputMethod, input.creditCardType, input.creditCardSecurityCode),
    convenienceStore: validateConvenienceStore(input.paymentInputMethod, input.convenienceStore),
    mobileCarrier: validateMobileCarrier(input.paymentInputMethod, input.mobileCarrier),
    enrollmentReasonValidateParam: validateEnrollmentReason(input.enrollmentReasonValidateParam),
    extendMetaData: validateExtendMetaData(input.extendMetaDataParam),
  }

  const {extendMetaData, ...rest} = details

  const hasError =
    Object.values(rest)
      .map(errorArray => errorArray.length)
      .some(length => length > 0)

  const hasErrorExtendMetaData = extendMetaData !== undefined
    ? Object.values(extendMetaData)
      .map(error => error.length)
      .some(length => length > 0)
    : false

  return {
    hasError: hasError || hasErrorExtendMetaData,
    errors: details,
  }
}
